import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

const getSelectedTeams = (teams: Team[], userIds: User["id"][] = []) =>
  teams.filter(({ users }) => users.length > 0 && users.every(({ id }) => userIds.includes(id)));

export default getSelectedTeams;
